module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Right-2-c47d92988da999989824be3de1745aa1.svg";